import { render, staticRenderFns } from "./announcementDeleteDialog.vue?vue&type=template&id=235156a7&scoped=true"
import script from "./announcementDeleteDialog.vue?vue&type=script&lang=js"
export * from "./announcementDeleteDialog.vue?vue&type=script&lang=js"
import style0 from "./announcementDeleteDialog.vue?vue&type=style&index=0&id=235156a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235156a7",
  null
  
)

export default component.exports